// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"0ecaedb0","487":"67f516eb","581":"085c1157"}[chunkId] + ".chunk.js";
};